export default __webpack_public_path__ + "static/media/facebook-open-in-browser.f4c06364.jpg";